import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faEnvelope,
  faBoxOpen,
  faTimes,
  faStore,
} from "@fortawesome/free-solid-svg-icons";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MahilaMandiWeeklyHome = () => {
  const [popup, setPopup] = useState({ type: "", seller: null });
  const [expandedHaat, setExpandedHaat] = useState(null);

  const sellers = [
    // 🏙️ Shaniwar Wada Bazaar (Saturday)
    {
        name: "Sakshi Deshmukh",
        district: "Pune",
        product: "Organic Jaggery & Honey",
        haatDay: "Saturday",
        haatLocation: "Shaniwar Wada Bazaar",
        sales: [50, 70, 65, 80],
        img: "https://via.placeholder.com/150x150/003366/FFFFFF?text=Sakshi",
    },
    {
        name: "Manisha Patil",
        district: "Pune",
        product: "Homemade Pickles & Chutneys",
        haatDay: "Saturday",
        haatLocation: "Shaniwar Wada Bazaar",
        sales: [40, 55, 60, 75],
        img: "https://via.placeholder.com/150x150/004C99/FFFFFF?text=Manisha",
    },
    {
        name: "Lata Bhosale",
        district: "Pune",
        product: "Traditional Sarees & Handloom",
        haatDay: "Saturday",
        haatLocation: "Shaniwar Wada Bazaar",
        sales: [35, 50, 65, 70],
        img: "https://via.placeholder.com/150x150/0059B3/FFFFFF?text=Lata",
    },

    // 🌾 Panchavati Market (Sunday)
    {
        name: "Rekha Jadhav",
        district: "Nashik",
        product: "Handmade Herbal Soaps",
        haatDay: "Sunday",
        haatLocation: "Panchavati Market",
        sales: [40, 60, 75, 90],
        img: "https://via.placeholder.com/150x150/004C99/FFFFFF?text=Rekha",
    },
    {
        name: "Kavita Pawar",
        district: "Nashik",
        product: "Millet-Based Bakery Products",
        haatDay: "Sunday",
        haatLocation: "Panchavati Market",
        sales: [30, 45, 50, 65],
        img: "https://via.placeholder.com/150x150/0066CC/FFFFFF?text=Kavita",
    },
    {
        name: "Snehal Gaikwad",
        district: "Nashik",
        product: "Handcrafted Jewelry & Accessories",
        haatDay: "Sunday",
        haatLocation: "Panchavati Market",
        sales: [25, 35, 40, 55],
        img: "https://via.placeholder.com/150x150/007ACC/FFFFFF?text=Snehal",
    },

    // 🌸 Rankala Haat (Friday)
    {
        name: "Anita More",
        district: "Kolhapur",
        product: "Homemade Snacks & Papad",
        haatDay: "Friday",
        haatLocation: "Rankala Haat",
        sales: [30, 45, 55, 70],
        img: "https://via.placeholder.com/150x150/002244/FFFFFF?text=Anita",
    },
    {
        name: "Rupali Shinde",
        district: "Kolhapur",
        product: "Kolhapuri Chappals & Leather Goods",
        haatDay: "Friday",
        haatLocation: "Rankala Haat",
        sales: [35, 50, 60, 75],
        img: "https://via.placeholder.com/150x150/003366/FFFFFF?text=Rupali",
    },
    {
        name: "Vaishali Mane",
        district: "Kolhapur",
        product: "Spice Mix & Masala Powders",
        haatDay: "Friday",
        haatLocation: "Rankala Haat",
        sales: [45, 60, 65, 80],
        img: "https://via.placeholder.com/150x150/004C99/FFFFFF?text=Vaishali",
    },
    ];


  const upcomingHaats = [
    {
      name: "Shaniwar Wada Bazaar",
      day: "Saturday",
      location: "Pune",
      sellers: sellers.filter((s) => s.haatDay === "Saturday"),
    },
    {
      name: "Panchavati Market",
      day: "Sunday",
      location: "Nashik",
      sellers: sellers.filter((s) => s.haatDay === "Sunday"),
    },
    {
      name: "Rankala Haat",
      day: "Friday",
      location: "Kolhapur",
      sellers: sellers.filter((s) => s.haatDay === "Friday"),
    },
  ];

  const data = {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: [
      {
        label: "Sales (units)",
        data: [60, 80, 75, 90],
        backgroundColor: "#00BFFF",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: { legend: { labels: { color: "#FFFFFF" } } },
    scales: {
      x: { ticks: { color: "#FFFFFF" }, grid: { color: "#333" } },
      y: { ticks: { color: "#FFFFFF" }, grid: { color: "#333" } },
    },
  };

  return (
    <div className="min-h-screen bg-black text-white p-4 md:p-8">
      <div className="flex flex-col justify-center mb-2">
        <h1 className="text-xl lg:text-2xl font-bold text-center text-rose-400 mb-2">
            SAKSHAM Shakti MahilaMandi — Weekly Haat Connect
        </h1>
        <p className="text-sm lg:text-lg text-center">Augmenting and extending Physical Weekly Haat by adding digital market reach and market visibility</p>
      </div>
      {/* Chart Section */}
      <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-8">
        <div className="w-full md:w-1/3 bg-gray-900 p-4 rounded-xl shadow-lg">
          <h2 className="text-lg font-semibold text-center text-rose-300 mb-2">
            Weekly Sales Overview
          </h2>
          <Bar data={data} options={options} />
        </div>
      </div>

      {/* Upcoming Haat Section */}
      <h2 className="text-lg lg:text-xl font-semibold text-rose-300 mb-4">
        🏪 Upcoming Haats
      </h2>

      {upcomingHaats.map((haat, index) => (
        <div
          key={index}
          className="bg-gray-900 p-4 mb-4 rounded-xl shadow-md hover:shadow-rose-500 transition duration-300"
        >
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div>
              <h3 className="text-sm lg:text-lg font-bold text-rose-300">
                {haat.name}
              </h3>
              <p className="text-gray-400 text-sm">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-1" />
                {haat.location} — {haat.day}
              </p>
            </div>
            <button
              className="bg-rose-600 hover:bg-rose-500 w-32 px-4 py-2 rounded-full mt-3 sm:mt-0"
              onClick={() =>
                setExpandedHaat(expandedHaat === index ? null : index)
              }
            >
              {expandedHaat === index ? "Hide Sellers" : "Show Sellers"}
            </button>
          </div>

          {expandedHaat === index && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-4">
              {haat.sellers.map((seller, i) => (
                <div
                  key={i}
                  className="bg-gray-800 p-4 rounded-xl text-center shadow-md"
                >
                  <img
                    src={seller.img}
                    alt={seller.name}
                    className="rounded-full w-24 h-24 mx-auto mb-3 border-2 border-rose-400"
                  />
                  <h4 className="text-lg font-semibold text-rose-300">
                    {seller.name}
                  </h4>
                  <p className="text-gray-400 text-sm">{seller.district}</p>
                  <p className="mt-2 text-sm">
                    🛍️ {seller.product}
                  </p>
                  <div className="flex justify-center gap-3 mt-4">
                    <button
                      className="bg-rose-600 hover:bg-rose-500 px-3 py-2 rounded-full text-sm"
                      onClick={() => setPopup({ type: "enquiry", seller })}
                    >
                      <FontAwesomeIcon icon={faEnvelope} className="mr-1" />
                      Enquiry
                    </button>
                    <button
                      className="bg-green-600 hover:bg-green-500 px-3 py-2 rounded-full text-sm"
                      onClick={() => setPopup({ type: "order", seller })}
                    >
                      <FontAwesomeIcon icon={faBoxOpen} className="mr-1" />
                      Order
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* Popup Modal */}
      {popup.seller && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-90 flex justify-center items-center z-50">
          <div className="bg-gray-900 p-6 rounded-xl w-11/12 md:w-1/2 relative">
            <button
              className="absolute w-10 top-3 right-3 text-gray-400 hover:text-white items-end justify-end text-right"
              onClick={() => setPopup({ type: "", seller: null })}
            >
              <FontAwesomeIcon icon={faTimes}/>
            </button>

            <h2 className="text-xl font-semibold text-rose-300 mb-3 text-center">
              {popup.type === "enquiry"
                ? `Enquiry to ${popup.seller.name}`
                : `Place Order with ${popup.seller.name}`}
            </h2>

            {popup.type === "enquiry" ? (
              <textarea
                placeholder="Type your question or enquiry..."
                className="w-full p-3 bg-gray-800 text-white rounded-lg h-28 mb-4"
              ></textarea>
            ) : (
              <div className="flex flex-col">
                <textarea
                    placeholder="Enter order details..."
                    className="w-full p-3 bg-gray-800 text-white rounded-lg h-24 mb-3"
                ></textarea>

                <textarea
                    placeholder="Other Remarks"
                    className="w-full p-3 bg-gray-800 text-white rounded-lg h-20 mb-3"
                ></textarea>

                <textarea
                    placeholder="Instructions"
                    className="w-full p-3 bg-gray-800 text-white rounded-lg h-20 mb-4"
                ></textarea>
                </div>

            )}

            <button className="bg-rose-600 hover:bg-rose-500 w-20 py-2 rounded-lg text-white font-semibold">
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MahilaMandiWeeklyHome;
